export const checkIsDeleteType = (key) => {
  return key === 'Delete';
};
export const checkIsBackspaceType = (key) => {
  return key === 'Backspace';
};
export const isSpaceAdded = (caretPosition, maskedSeparation) => {
  const modulo = caretPosition % (maskedSeparation + 1);
  return modulo === 0;
};
export const calculateNewCaret = (key, caretPosition, separationLength) => {
  let newCaretPosition = caretPosition;
  if (
    checkIsDeleteType(key) &&
    isSpaceAdded(newCaretPosition + 1, separationLength)
  ) {
    newCaretPosition += 1;
  } else if (
    !checkIsDeleteType(key) &&
    !checkIsBackspaceType(key) &&
    isSpaceAdded(newCaretPosition, separationLength)
  ) {
    newCaretPosition += 1;
  }
  return newCaretPosition;
};
